import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";
import { useGetOrderDetailsDataQuery } from "../../../services/myAccountAPI";
import { Link } from "react-router-dom";
import { useGetCartCountQuery } from "../../../services/cartPageAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";

function Index() {
  const orderId = localStorage.getItem("OrderId");
  const UseId = localStorage.getItem("gridMarker");
  const OrderMainId = localStorage.getItem("OrderMainId");

  const { refetch: refetchCartCount } = useGetCartCountQuery();

  console.log("orderId", orderId);
  console.log("UseId", UseId);

  const { data: colorthemeData } = useGetColorThemeQuery();

  console.log(orderId);
  const { data, error, isLoading } = useGetOrderDetailsDataQuery({
    id: OrderMainId,
    order_id: orderId,
  });

  useEffect(() => {
    refetchCartCount();
  }, [refetchCartCount]);

  if (isLoading) return <p>Loading order details...</p>;
  if (error) return <p>Error loading order details</p>;

  const order = data?.order;
  if (!order) return <p>Order not found</p>;

  return (
    <div>
      <div className="payment-success">
        <FontAwesomeIcon icon={faCheckCircle} />
        <h3>Order Successfull</h3>

        <div className="order-details-container">
          <div className="order-details-header">
            <div className="order-summary">
              <h1>Order Details</h1>
              <div className="order-meta">
                <div className="order-id">
                  <span>Order ID:</span>
                  <strong>{order.order_id}</strong>
                </div>
                <div className="order-date">
                  <span className="ml-10">Order Date:</span>
                  <strong>{order.created_at}</strong>
                </div>
                <div className="order-status">
                  <span className="ml-10">Status:</span>
                  <strong
                    className={`status-badge ${order.order_status
                      .toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {order.order_status === "order_placed"
                      ? "Order Placed"
                      : order.order_status === "processing"
                        ? "Processing"
                        : order.order_status === "shipped"
                          ? "Shipped"
                          : order.order_status === "delivered"
                            ? "Delivered"
                            : order.order_status === "cancelled"
                              ? "Cancelled"
                              : "Unknown Status"}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          <div className="order-details-grid">
            <div className="order-section customer-details">
              <h3>Billing Information</h3>
              <div className="customer-info">
                <p>
                  <strong>
                    {data.billing_address?.first_name}{" "}
                    {data.billing_address?.last_name}
                  </strong>
                </p>
                <p>{data.billing_address?.street_address}</p>
                <p>
                  {data.billing_address?.town_city},{" "}
                  {data.billing_address?.state} {data.billing_address?.pin_code}
                </p>
                <p>Email: {data.billing_address?.email}</p>
                <p>Phone: {data.billing_address?.phone}</p>
              </div>
            </div>

            <div className="order-section payment-details">
              <h3>Order Summary</h3>
              <div className="payment-info">
                <div className="price-breakdown">
                  <div className="price-item border-none mb-4">
                    <span>Subtotal</span>
                    <span>${order.subtotal_selling_price}</span>
                  </div>

                  {order?.shipping_rate && order?.shipping_rate > 0 ? (<div className="price-item border-none mb-4">
                    <span>Shipping Rate</span>
                    <span>${order?.shipping_rate}</span>
                  </div>) : (<div className="price-item border-none mb-4">
                    <span>Free</span>
                    <span>$0</span>
                  </div>)}

                  {order?.coupons?.length > 0 && (
                    <div>
                      <div>
                        <h6 className="text-start">Coupon Applied :</h6>
                        {order?.coupons?.map((coupon) => (
                          <div className="price-item-discount">
                            <span>{coupon?.coupon_code}</span>
                            <span>${coupon.discount_amount}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="price-item total">
                    <strong>Total</strong>
                    <strong>${order.final_total_amount}</strong>
                  </div>
                </div>
                <div className="payment-status">
                  <span>Payment Status: </span>
                  <strong
                    className={`status-badge ${order.payment_status
                      .toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {order.payment_status}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          <div className="order-items">
            <h3>Order Items</h3>
            <table>
              <thead
                style={{
                  backgroundColor:
                    colorthemeData?.color_themes?.[0]?.primary_color ||
                    "#a76d50",
                }}
              >
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <div className="product-info">
                        {item.product_main_image_url_large && (
                          <img
                            src={item.product_main_image_url_large}
                            alt={item.product_name}
                            className="product-thumbnail"
                            loading="lazy"
                          />
                        )}
                        <span className="product-name text-start">
                          {item.product_name}
                          {item?.variant_details?.length > 0 && (
                            <div style={{ fontSize: "13px", color: "gray" }}>
                              {item?.variant_details?.map((v, index) => (
                                <div key={index}><b>{v.variant_attribute_name}</b> : {v.variant_value_name}</div>
                              ))}
                            </div>
                          )}
                        </span>
                      </div>
                    </td>
                    <td>{item.quantity}</td>
                    <td>${item.product_selling_unit_price}</td>
                    <td>${item.line_total_selling_price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row justify-content-center">
          <Link to="/shop">
            <button
              className="primary-button"
              style={{
                backgroundColor:
                  colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
              }}
            >
              Continue Shopping
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Index;
